import { create } from 'zustand';

// Persisted UI preferences (currently just the desktop sidebar collapse state).
const STORAGE_KEY = 'sidebarCollapsed';

const readInitial = (): boolean => {
  try {
    return localStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    return false;
  }
};

const persist = (value: boolean) => {
  try {
    localStorage.setItem(STORAGE_KEY, value ? '1' : '0');
  } catch {
    /* localStorage unavailable — keep in-memory only */
  }
};

interface UiState {
  /** Desktop sidebar collapsed to an icon-only rail. Ignored on mobile. */
  sidebarCollapsed: boolean;
  toggleSidebar: () => void;
  setSidebarCollapsed: (value: boolean) => void;
}

export const useUiStore = create<UiState>((set) => ({
  sidebarCollapsed: readInitial(),
  toggleSidebar: () =>
    set((s) => {
      const next = !s.sidebarCollapsed;
      persist(next);
      return { sidebarCollapsed: next };
    }),
  setSidebarCollapsed: (value) => {
    persist(value);
    set({ sidebarCollapsed: value });
  },
}));
